var map = {
	"./BbdaClustering.js": 427,
	"./BbdaInteractiveDashboard.js": 813,
	"./BbdaRegression.js": 1784,
	"./CarpoolingApp.js": 9171,
	"./MentionlyticsSentiment.js": 1731,
	"./SpotifyAPIProject.js": 8799,
	"./SpotifyPlaylistCreatorProject.js": 1809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7615;